import React, { Component } from "react";
import { Link } from "react-router-dom";

class MenuProcedimento extends Component {
  render() {
    return (
      <li className="nav-item">
        <Link to="/procedimento/consulta" className="nav-link">
          <i className="link-icon icon-list" />
          <span className="menu-title">Procedimento</span>
          <i className="menu-arrow" />
        </Link>
        <div className="submenu">
          <ul className="submenu-item">
            <li className="nav-item">
              <Link className="nav-link" to="/procedimento/consulta">
                Consultar
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/procedimento/cadastro">
                Novo Cadastro
              </Link>
            </li>
          </ul>
        </div>
      </li>
    );
  }
}

export default MenuProcedimento;
